import { Box } from '@fhs-legacy/universal-components';

const PaymentSelection = Box.withConfig({
  paddingBottom: '$4',
  marginBottom: '$16',
});

export default PaymentSelection;
